import React, {FunctionComponent} from "react";
import WizardStep from "../WizardStep";
import statusShipping from "../../../images/Progress/progress_versand.svg";
import GradientButton from "../../../commonComponents/GradientButton";
import {Step} from "../../WizardMap";
import {NavigationProps} from "../../slideRouter/navigationHook";
import {useDispatch} from "react-redux";
import {removePickUp} from "../../state/contactSlice";
import {Box} from "@material-ui/core";
import InfoBox from "../../../commonComponents/InfoBox";

const StepShippingType: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const dispatch = useDispatch();

    const handlePickUp = () => gotoNextSlide(Step.SHIPPING_INFO);
    const handleSelfSend = () => {
        dispatch(removePickUp());
        gotoNextSlide(Step.PAYMENT);
    };

    return (
        <WizardStep
            title={"Bitte wählen Sie eine Versandart aus"}
            icon={statusShipping}
            backButton
            onBackClick={gotoPrevSlide}
        >
            <Box marginBottom={3} position={"relative"}>
                <GradientButton
                    text={"Abholen von Zuhause"}
                    onClick={handlePickUp}
                    disabled={true}
                />
                <InfoBox
                    text={"Abholungen sind zur Zeit nicht möglich."}
                    buttonContainerStyle={{marginLeft: 7}}
                />
            </Box>

            <div style={{position: "relative"}}>
                <GradientButton
                    text={"Selbst versenden"}
                    onClick={handleSelfSend}
                />
                <InfoBox
                    text={"Kosten für den Versand werden nicht übernommen."}
                    buttonContainerStyle={{marginLeft: 7}}
                />
            </div>
        </WizardStep>
    );
};

export default StepShippingType;
